import { openBlock as t, createElementBlock as e, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ l("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), c = /* @__PURE__ */ l("path", {
  fill: "#0052B4",
  d: "M4.134 7.824A19.927 19.927 0 0 0 .69 14.783h10.404l-6.959-6.96Zm35.176 6.959a19.93 19.93 0 0 0-3.445-6.96l-6.959 6.96h10.405ZM.689 25.218a19.929 19.929 0 0 0 3.445 6.959l6.959-6.96H.689ZM32.176 4.135A19.928 19.928 0 0 0 25.217.689v10.405l6.96-6.96ZM7.823 35.866a19.93 19.93 0 0 0 6.96 3.445V28.907l-6.96 6.959ZM14.782.69a19.929 19.929 0 0 0-6.959 3.445l6.96 6.959V.689Zm10.435 38.621a19.93 19.93 0 0 0 6.959-3.445l-6.959-6.96v10.405Zm3.689-14.093 6.96 6.959a19.93 19.93 0 0 0 3.445-6.96H28.906Z"
}, null, -1), a = /* @__PURE__ */ l("path", {
  fill: "#D80027",
  d: "M39.83 17.391H22.61V.17a20.198 20.198 0 0 0-5.218 0v17.222H.17a20.2 20.2 0 0 0 0 5.218h17.222v17.22a20.194 20.194 0 0 0 5.218 0V22.609h17.22a20.212 20.212 0 0 0 0-5.218Z"
}, null, -1), h = /* @__PURE__ */ l("path", {
  fill: "#D80027",
  d: "m25.217 25.218 8.925 8.924c.41-.41.802-.84 1.175-1.284l-7.64-7.64h-2.46Zm-10.435 0-8.924 8.924c.41.41.839.802 1.284 1.176l7.64-7.641v-2.46Zm0-10.435L5.858 5.858c-.41.41-.802.84-1.176 1.284l7.64 7.64h2.46Zm10.435 0 8.925-8.925c-.41-.41-.84-.802-1.284-1.176l-7.64 7.641v2.46Z"
}, null, -1), s = [
  n,
  c,
  a,
  h
];
function d(i, Z) {
  return t(), e("svg", o, [...s]);
}
const m = { render: d };
export {
  m as default,
  d as render
};
